module.exports = __webpack_public_path__ + "static/header-mobile.af412b88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SpeakerSections/header-mobile.svg
// module id = 710
// module chunks = 195234328731080